import script from "./phoneCode.vue?vue&type=script&setup=true&lang=js"
export * from "./phoneCode.vue?vue&type=script&setup=true&lang=js"

import "./phoneCode.vue?vue&type=style&index=0&id=115b1dee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115b1dee"]])

export default __exports__